









































import { defineComponent, onMounted, ref } from "@vue/composition-api"
import { GateNames} from "@/app/models/iot-gate.model"
import { BookingModel } from "@/app/models/booking.model"
import Hint from "@/app/components/common/Hint.vue"
import { IotGateModelWithSpamPrevention } from "@/app/models/iot-gate-model-with-spam-protection.model";
import {useIoTControl} from "@/app/reactive/iot-control/iot-control.reactive";

export default defineComponent({
  components: {Hint},
  props: {
    booking: {
      type: Object as () => BookingModel,
      default: {} as BookingModel,
    },
  },
  setup(props) {
    const { openGate, gates, fetchGatesWithSpamPrevention } = useIoTControl()

    const hasSuccessGateSnackbar = ref(false)
    const hasErrorGateSnackbar = ref(false)
    const hasWaitToTryAgainSnackbar = ref(false)
    const defaultSpamTimeout = 3000
    let spamTimeout = defaultSpamTimeout

    type GateIcons = "mdi-walk" | "mdi-garage-variant" | "mdi-boom-gate"

    // Will be later replaced by a new gate structure where the icon probably is included
    const iconMap = new Map<GateNames, GateIcons>([
      ["main", "mdi-garage-variant"],
      ["mainInner", "mdi-garage-variant"],
      ["mainOuter", "mdi-garage-variant"],
      ["pedestrian", "mdi-walk"],
      ["barrier", "mdi-boom-gate"],
      ["barrierEntry", "mdi-boom-gate"],
      ["barrierExit", "mdi-boom-gate"],
      ["barrierInner", "mdi-boom-gate"],
      ["barrierOuter", "mdi-boom-gate"],
    ])

    onMounted(async () => {
      await fetchGatesWithSpamPrevention(props.booking?.facilityId)
    })

    async function triggerGate(gate: IotGateModelWithSpamPrevention) {
      gate.opening = true
      gate.spamPrevention = true

      const response = await openGate(
        props.booking.id,
        gate.gateId,
      )

      if (response.wasSuccessful) {
        hasSuccessGateSnackbar.value = true
        gate.opening = false
      } else if (response.status === 429) {
        hasWaitToTryAgainSnackbar.value = true
        spamTimeout = 20000
      } else {
        hasErrorGateSnackbar.value = true
      }

      setTimeout(() => {
        gate.spamPrevention = false
        gate.opening = false
        spamTimeout = defaultSpamTimeout
      }, spamTimeout)
    }

    return {
      gates,
      triggerGate,
      iconMap,
      hasSuccessGateSnackbar,
      hasErrorGateSnackbar,
      hasWaitToTryAgainSnackbar,
    }
  },
})
